export default {
  buttonTitle: {
    en: 'Gmail',
  },
}
